import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodIconComponent } from './payment-method-icon.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PaymentMethodIconComponent],
  imports: [CommonModule, MatIconModule],
  exports: [PaymentMethodIconComponent],
})
export class PaymentMethodIconModule {}
